import React, {useState} from "react";
import './contacts.css';
import IconsSiteFxBTC57 from "../../../static/img/SVG/IconsSiteFxBTC57.svg";
import IconsSiteFxBTC58 from "../../../static/img/SVG/IconsSiteFxBTC58.svg";
import axios from "axios";
import CompanyContact01 from "../../../static/img/Company/CompanyContact/CompanyContact01.svg";
import CompanyContact02 from "../../../static/img/Company/CompanyContact/CompanyContact02.svg";
import Feedback02 from "../../../static/img/Company/CompanyContact/Feedback02.jpg";
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";
import LayoutMain from "../../00LayoutMain/LayoutMain";
import SendQuestion from "../../00LayoutMain/TopMenu/SendQuestion/SendQuestion";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";

let reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{1,4})$/;

function CompanyContactSourceGatsby (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}
    const [eMailValue, setEMailValue] = useState('');
    const [TextValue, setTextValue] = useState('');
    const [eMailErrorVisible, setEMailErrorVisible] = useState('isNoVisible');
    const [TextErrorVisible, setTextErrorVisible] = useState('isNoVisible');
    const [TraderFeedbackMainInVisible, setTraderFeedbackMainInVisible] = useState('isNoVisible');
    const [TraderFeedbackSuccessVisible, setTraderFeedbackSuccessVisible] = useState('isNoVisible');


    function handleMailChange(event) {
            setEMailValue(event.target.value);
            if(reg.test(eMailValue) === true)  {
                setEMailErrorVisible( "isNoVisible");
                event.preventDefault();
            }
        }

    function handleTextChange(event) {
            setTextValue(event.target.value);
            setTextErrorVisible("isNoVisible");
        }

    function checkSubmit(event) {
            if(reg.test(eMailValue) === false)  {setEMailErrorVisible("isVisible");}
            else {setEMailErrorVisible("isNoVisible");}
            if(TextValue === '')  {setTextErrorVisible("isVisible");
                event.preventDefault();
            }
        }


    async function handleSubmit(e) {
            if(reg.test(eMailValue) === false)  {
                setEMailErrorVisible("isVisible");
                e.preventDefault();
            }
            else {setEMailErrorVisible("isNoVisible");}
            if(TextValue === '')  {
                setTextErrorVisible("isVisible");
                e.preventDefault();
            }
            if (reg.test(eMailValue) && (TextValue !== '')) {
                e.preventDefault();
                let SubjectMail = 'FeedBack from FXBitcoinforex!';
                let output = TextValue + eMailValue;
                let data = {
                    SubjectMail,
                    output
                };
                axios
                    .post('https://myadmin.fxbitcoin.org/send', data)
                    .then(() => {
                            //console.log('Mail Created');
                            setTraderFeedbackMainInVisible("isNoVisible");
                            setTraderFeedbackSuccessVisible('isVisible');
                        }
                    )
                    .catch(e => console.log(e));
            }
        }

            return (
        <LayoutMain title={props.title} description={props.description} lang={props.lang}>
            <main className="CompanyContact StandartPage">
                <div className="StandartNOTitle"/>
                <div className="StandartWhitePart">
                    <div className="StandartWhitePartTitle">
                        <div className="StandartWhitePartTitleText"><TextSource ArrIndex= 'PageContact0012'>Как с нами связаться</TextSource></div>
                        <SendQuestion lang={props.lang}/>
                    </div>
                    <div className="CompanyContactPartMailsOut">
                        <div className="CompanyContactPartMails">
                            <div className="CompanyContactPartMailsElement01">
                                <div className="CompanyContactPartMailsElementTitle"><TextSource ArrIndex= 'PageContact0015'>Техническая поддержка клиентов</TextSource>  </div>
                                <div className="CompanyContactPartMailsElementMail"><img alt='alt' src={IconsSiteFxBTC57} width="16" height="12"/>support@fxbitcoin.org</div>
                                <div className="CompanyContactPartMailsElementTime"><img alt='alt' src={IconsSiteFxBTC58} width="16" height="16"/><TextSource ArrIndex= 'PageContact0020'>Круглосуточно</TextSource> </div>
                            </div>
                            <div className="HrGrayVerticalLine HrGrayVerticalLine01"/>
                            <div className="CompanyContactGorizontalLine"/>
                            <div className="CompanyContactPartMailsElement02">
                                <div className="CompanyContactPartMailsElementTitle"><TextSource ArrIndex= 'PageContact0025'>Вопросы по выводу и зачислению средств</TextSource> </div>
                                <div className="CompanyContactPartMailsElementMail"><img alt='alt' src={IconsSiteFxBTC57} width="16" height="12"/>finance@fxbitcoin.org</div>
                                <div className="CompanyContactPartMailsElementTime"><img alt='alt' src={IconsSiteFxBTC58} width="16" height="16"/><TextSource ArrIndex= 'PageContact0030'>Круглосуточно</TextSource> </div>
                            </div>
                            <div className="HrGrayVerticalLine HrGrayVerticalLine02"/>
                            <div className="CompanyContactGorizontalLine"/>
                            <div className="CompanyContactPartMailsElement03">
                                <div className="CompanyContactPartMailsElementTitle"><TextSource ArrIndex= 'PageContact0035'>Региональное развитие (партнерский отдел)</TextSource> </div>
                                <div className="CompanyContactPartMailsElementMail"><img alt='alt' src={IconsSiteFxBTC57} width="16" height="12"/>partner@fxbitcoin.org</div>
                                <div className="CompanyContactPartMailsElementTime"><img alt='alt' src={IconsSiteFxBTC58} width="16" height="16"/><TextSource ArrIndex= 'PageContact0040'>Круглосуточно</TextSource> </div>
                            </div>
                            <div className="HrGrayVerticalLine HrGrayVerticalLine03"/>
                            <div className="CompanyContactGorizontalLine"/>
                            <div className="CompanyContactPartMailsElement04">
                                <div className="CompanyContactPartMailsElementTitle"><TextSource ArrIndex= 'PageContact0045'>Отдел споров и жалоб</TextSource>  </div>
                                <div className="CompanyContactPartMailsElementMail"><img alt='alt' src={IconsSiteFxBTC57} width="16" height="12"/>claim@fxbitcoin.org</div>
                                <div className="CompanyContactPartMailsElementTime"><img alt='alt' src={IconsSiteFxBTC58} width="16" height="16"/><TextSource ArrIndex= 'PageContact0050'>c 10 до 20</TextSource> </div>
                            </div>
                        </div>
                    </div>
                    <div className="CompanyContactCentral"> <img alt='alt' src={CompanyContact01} width="38" height="32"/>
                        <div className="CompanyContactCentralTitle"><TextSource ArrIndex= 'PageContact0055'>ИЛИ ЗВОНИТЕ ПО ТЕЛЕФОНАМ</TextSource> </div>
                        <div className="CompanyContactCentralTelephone">8 (800) 775-65-06 <img alt='alt' src={CompanyContact01} width="38" height="32"/> <p/> 8 (800) 775-65-06</div>
                        <div className="CompanyContactCentralTime"><TextSource ArrIndex= 'PageContact0060'>С 10 ДО 21 ПО МСК</TextSource> </div>
                    </div>
                    <div className="HrGrayGorizontalLine"/>
                    <div className="StandartH2 CompanyContactPlace02"><TextSource ArrIndex= 'PageContact0065'>Вопросы или замечания по работе компании</TextSource> </div>
                        <div className="TraderFeedback">
                             <div className={"TraderFeedbackMainIn " + TraderFeedbackMainInVisible}>
                                    <form  onSubmit={handleSubmit}>
                                        <label htmlFor="email">E-mail:</label>
                                        <input type="text" placeholder='Your Mail' name="email" value={eMailValue} onChange={handleMailChange} onBlur={checkSubmit} />
                                        <div className={'TraderFeedbackError '+ eMailErrorVisible} ><TextSource ArrIndex= 'PageContact0095'>Неверный е-мейл</TextSource> </div>
                                        <label htmlFor="yourtext"><TextSource ArrIndex= 'PageContact0070'>Ваше сообщение:</TextSource> </label>
                                        <textarea name="yourtext" placeholder='Your Message'  rows="10" value={TextValue} onChange={handleTextChange} onBlur={checkSubmit} />
                                        <div className={'TraderFeedbackError '+ TextErrorVisible}><TextSource ArrIndex= 'PageContact0090'>Вы ничего не ввели</TextSource> </div>
                                        <label htmlFor="none"><div> </div></label>
                                        <div className="StandartButtonOut CompanyContactPlace03">
                                            <input type="submit" value={JSON.parse(props.PrerenderTexts['PageContact0100'])[props.lang]} className='ButtonBlue'/>
                                        </div>
                                    </form>
                                </div>
                                <div className={"TraderFeedbackSuccess " + TraderFeedbackSuccessVisible}>
                                    <img alt='Ifyoudontseeimages' src={Feedback02}/>
                                    <div className="TraderFeedbackSuccessTitle"><TextSource ArrIndex= 'PageContact0075'>Письмо успешно отправлено</TextSource> </div>
                                    <div className="TraderFeedbackSuccessText"><TextSource ArrIndex= 'PageContact0080'>Письмо отправлено! Возможно, вы найдете ответ в</TextSource> 
                                        <ChangeLink lang={props.lang} to='/Trader/FAQ'>FAQ</ChangeLink>
                                    </div>


                                </div>
                                <div className="TraderFeedbackMainImg">
                                    <img alt='Ifyoudontseeimages' src={CompanyContact02} width="180px" height='80px'/>
                                    <div className="TraderFeedbackMainImgText"><TextSource ArrIndex= 'PageContact0085'>Мы пришлем вам ответ на электронную почту</TextSource> </div>
                                </div>


                        </div>
                </div>
            </main>
        </LayoutMain>

    )}

export default CompanyContactSourceGatsby